export default {
  'custom.lists.title': 'Listas',
  'custom.lists.tab.groups': 'Grupos',
  'custom.lists.tab.favorites': 'Favoritos',
  'custom.lists.text.created': 'El elemento ha sido creado correctamente.',
  'custom.lists.text.removed': 'El elemento ha sido eliminado correctamente.',
  'custom.lists.text.edited': 'El elemento ha sido actualizado correctamente.',
  'custom.lists.text.listGroups': 'Grupos de Listas',
  'custom.lists.text.listEntityGroups': 'Grupos de Entidades Dinámicas',

  'custom.lists.text.type': 'Tipo',
  'custom.lists.text.cliente': 'Cliente',
  'custom.lists.text.direccion': 'Dirección',
  'custom.lists.text.distrito': 'Distrito',
  'custom.lists.text.completed': 'Completado',

  'customList.text.detail': 'Detalles',
  'customList.text.cancel': 'Cancelar',
  'customList.text.complete': 'Completar',
  'customList.text.approve': 'Aprobar',
  'customList.text.reject': 'Rechazar',
  'customList.text.execute': 'Ejecutar',
  'customList.text.sign': 'Firmar',
  'customList.text.reassign': 'Re-Asignar',

  'custom.lists.text.message.cancel': 'El elemento ha sido cancelado correctamente',
  'custom.lists.text.message.approve': 'El elemento ha sido aprobado correctamente',
  'custom.lists.text.message.execute': 'El elemento ha sido ejecutado correctamente',
  'custom.lists.text.message.sign': 'El elemento ha sido firmado correctamente',
  'custom.lists.text.message.reassign': 'El elemento ha sido re-asignado correctamente',
};
